import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row d-flex justify-content-center" }
const _hoisted_2 = { class: "col-12 text-center" }
const _hoisted_3 = { class: "row d-flex justify-content-center mb-4" }
const _hoisted_4 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  action: "#",
  id: "formUserData",
  class: "needs-validation",
  autocomplete: "off"
}
const _hoisted_8 = { class: "container" }
const _hoisted_9 = {
  key: 0,
  class: "row d-flex justify-content-center"
}
const _hoisted_10 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_11 = {
  key: 1,
  class: "row d-flex justify-content-center"
}
const _hoisted_12 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_13 = {
  key: 2,
  class: "row d-flex justify-content-center"
}
const _hoisted_14 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_15 = {
  key: 3,
  class: "row d-flex justify-content-center"
}
const _hoisted_16 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_17 = {
  key: 4,
  class: "row d-flex justify-content-center"
}
const _hoisted_18 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_19 = {
  key: 5,
  class: "row d-flex justify-content-center"
}
const _hoisted_20 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_21 = { class: "row d-flex justify-content-center form-group" }
const _hoisted_22 = { class: "form-check col-xl-8 col-md-10 col-12" }
const _hoisted_23 = {
  for: "privacy",
  style: {"white-space":"normal !important","overflow":"unset !important","font-weight":"300"}
}
const _hoisted_24 = { class: "row d-flex justify-content-center" }
const _hoisted_25 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "g-recaptcha-response",
  style: {"display":"none"}
}, "Google Recaptcha", -1)
const _hoisted_27 = {
  key: 0,
  class: "form-feedback just-validate-error-label",
  style: {"text-align":"start"},
  id: "validationCustom03-error-0"
}
const _hoisted_28 = { class: "row d-flex justify-content-center mt-4" }
const _hoisted_29 = { class: "col-xl-8 col-md-10 col-12 d-grid gap-2" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  class: "progress progress-indeterminate"
}
const _hoisted_32 = { class: "visually-hidden" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", {
  class: "progress-bar",
  role: "progressbar"
}, null, -1)
const _hoisted_34 = {
  key: 0,
  class: "row d-flex justify-content-center mt-4"
}
const _hoisted_35 = { class: "col-xl-8 col-md-10 col-12 d-grid gap-2" }
const _hoisted_36 = {
  class: "alert alert-danger d-flex justify-content-left",
  role: "alert"
}
const _hoisted_37 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_38 = { class: "modal-content" }
const _hoisted_39 = { class: "modal-header" }
const _hoisted_40 = {
  class: "modal-title h5 no_toc",
  id: "alertPrivacyModalLabel"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close search-link d-none d-md-block",
  "data-bs-dismiss": "modal",
  "aria-label": "Chiudi finestra modale"
}, null, -1)
const _hoisted_42 = { class: "modal-body" }
const _hoisted_43 = { class: "modal-footer" }
const _hoisted_44 = {
  class: "modal-dialog modal-dialog-centered modal-xl",
  role: "document"
}
const _hoisted_45 = { class: "modal-content" }
const _hoisted_46 = { class: "modal-header" }
const _hoisted_47 = {
  class: "modal-title h5 no_toc",
  id: "privacyModalLabel"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close search-link d-none d-md-block",
  "data-bs-dismiss": "modal",
  "aria-label": "Chiudi finestra modale"
}, null, -1)
const _hoisted_49 = { class: "modal-body" }
const _hoisted_50 = { class: "modal-footer" }

import { computed, onMounted, ref, inject } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "../../models/Store/store";
import { useWidget } from "../../composables/useWidget";
import { useTenantConfig } from "../../composables/useTenantConfig";
import { useFormValidation } from "../../composables/useFormValidation";
import { useI18n } from "vue-i18n";
import api from "@/services/BookingService";
import _ from "lodash";
import { SpidItemResponse } from "@/models/Spid/SpidItemResponse";
import { RegistrationConfigItem, TenantBookingConfiguration } from "@/models/Configuration/TenantBookingConfiguration";
import Utils from "../../models/Utils/utils";
import { VueRecaptcha } from "vue-recaptcha";
import Privacy from "../../components/Privacy.vue";
import { FormValidate, Modal } from "bootstrap-italia";
import { ExternalLoginBackUrlData } from "@/models/ExternalLogin/ExternalLoginBackUrlData";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookUserData',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const { recaptchaClientKey } = useWidget();
const formValidation = useFormValidation();
const { hasConfiguration, hasUserDataAsExternalLogin, getUserDataExternalLoginLink } = useTenantConfig();
const { t } = useI18n();
const recaptcha = ref(null);
const localeCode = ref("it-IT");
const emitter = inject("emitter");

const name = ref("");
const lastname = ref("");
const mobilephone = ref("");
const email = ref("");
const cf = ref("");
const pod = ref("");
const authnReqId = ref("");

const forceSeePrivacy = ref(false);
const hasSeenPrivacy = ref(false);
const hasAcceptedPrivacy = ref(false);

const nameVisibility = ref(true);
const lastNameVisibility = ref(true);
const mobilePhoneVisibility = ref(true);
const emailVisibility = ref(true);
const taxCodeVisibility = ref(true);
const podVisibility = ref(true);

const nameEnabled = ref(true);
const lastNameEnabled = ref(true);
const mobilePhoneEnabled = ref(true);
const emailEnabled = ref(true);
const taxCodeEnabled = ref(true);
const podEnabled = ref(true);

const nameRequired = ref(true);
const lastNameRequired = ref(true);
const mobilePhoneRequired = ref(true);
const emailRequired = ref(true);
const taxCodeRequired = ref(false);
const podRequired = ref(false);
const podCheckRule = ref(null);

const reCaptchaErrorVisibility = ref(false);

const tokenReCaptcha = ref("");

const saving = ref(false);
const saveError = ref(false);
const saveErrorMessage = ref("");
const alertPrivacyRef = ref(null);
const privacyRef = ref(null);

const attentionTitle = computed(() => {
    return t("common.attention");
});

const privacyTitle = computed(() => {
    return _.capitalize(t("privacy.privacyLink"));
});

const validate = ref<any>(null);
let alertPrivacyModal: any;
let privacyModal: any;

onMounted(() => {
    localeCode.value = t("settings.localeCode");
    manageFieldsVisibility();

    alertPrivacyModal = new Modal(alertPrivacyRef.value, { backdrop: "static" });
    privacyModal = new Modal(privacyRef.value, { backdrop: "static" });
    validate.value = new FormValidate("#formUserData" as any, {
        errorFieldCssClass: "is-invalid",
        errorLabelCssClass: "form-feedback",
        errorLabelStyle: "",
        focusInvalidField: true,
        successLabelCssClass: "labelblack"
    });

    if (nameVisibility.value && nameRequired.value) {
        validate.value.addField("#firstName", [
            {
                rule: "required",
                errorMessage: t("required.firstName")
            }
        ]);
    }

    if (lastNameVisibility.value && lastNameRequired.value) {
        validate.value.addField("#lastName", [
            {
                rule: "required",
                errorMessage: t("required.lastName")
            }
        ]);
    }

    if (mobilePhoneVisibility.value) {
        if (mobilePhoneRequired.value) {
            validate.value.addField("#mobilephone", [
                {
                    rule: "required",
                    errorMessage: t("required.phoneNumber")
                }
            ]);

            validate.value.addField("#mobilephone", [
                {
                    validator: (value: string) => {
                        if (!formValidation.validatePhoneNumber(value)) {
                            return false;
                        }
                        return true;
                    },
                    errorMessage: t("invalid.phoneNumber")
                }
            ]);
        } else {
            validate.value.addField("#mobilephone", [
                {
                    validator: (value: string) => {
                        if (value.length > 0 && !formValidation.validatePhoneNumber(value)) {
                            return false;
                        }
                        return true;
                    },
                    errorMessage: t("invalid.phoneNumber")
                }
            ]);
        }
    }

    if (emailVisibility.value) {
        if (emailRequired.value) {
            validate.value.addField("#email", [
                {
                    rule: "required",
                    errorMessage: t("required.emailAddress")
                }
            ]);
            validate.value.addField("#email", [
                {
                    validator: (value: string) => {
                        console.log("inizio - valido email");
                        if (!formValidation.validateEmail(value)) {
                            return false;
                        }
                        return true;
                    },
                    errorMessage: t("invalid.emailAddress")
                }
            ]);
        } else {
            validate.value.addField("#email", [
                {
                    validator: (value: string) => {
                        if (value.length > 0 && !formValidation.validateEmail(value)) {
                            return false;
                        }
                        return true;
                    },
                    errorMessage: t("invalid.emailAddress")
                }
            ]);
        }
    }

    if (taxCodeVisibility.value) {
        if (taxCodeRequired.value) {
            validate.value.addField("#cf", [
                {
                    rule: "required",
                    errorMessage: t("required.taxCode")
                }
            ]);
            validate.value.addField("#cf", [
                {
                    validator: (value: string) => {
                        if (!formValidation.validateTaxCodeOrPIVA(value)) {
                            return false;
                        }
                        return true;
                    },
                    errorMessage: t("invalid.taxCode")
                }
            ]);
        }
        if (!taxCodeRequired.value && cf.value !== "" && cf.value !== null) {
            validate.value.addField("#cf", [
                {
                    validator: (value: string) => {
                        if (!formValidation.validateTaxCodeOrPIVA(value)) {
                            return false;
                        }
                        return true;
                    },
                    errorMessage: t("invalid.taxCode")
                }
            ]);
        }
    }

    if (podVisibility.value) {
        if (podRequired.value) {
            validate.value.addField("#pod", [
                {
                    rule: "required",
                    errorMessage: t("required.pod")
                }
            ]);
        }

        if (podCheckRule.value) {
            validate.value.addField("#pod", [
            {
                    validator: (value: string) => {
                        if (podCheckRule.value(value, true)) {
                            return false;
                        }
                        return true;
                    },
                    errorMessage: t("notrequiredbutcheck.pod")
                },
                {
                    validator: (value: string) => {
                        if (podCheckRule.value(value, false)) {
                            return false;
                        }
                        return true;
                    },
                    errorMessage: t("invalid.pod")
                }
            ]);
        }
    }

    validate.value.addField("#privacy", [
        {
            rule: "required",
            errorMessage: t("required.privacy")
        }
    ]);

    if (store.bookedit) {
        name.value = store.bookedit.firstName;
        lastname.value = store.bookedit.lastName;
        cf.value = store.bookedit.taxCode;
        email.value = store.bookedit.email;
        mobilephone.value = store.bookedit.mobilePhone;

        if (store.bookedit.authnReqId) {
            disableInputFields();
        }
    } else if (store.userLoggedData) {
        name.value = store.userLoggedData.firstName;
        lastname.value = store.userLoggedData.lastName;
        cf.value = store.userLoggedData.taxCode;
        email.value = store.userLoggedData.email;
        mobilephone.value = store.userLoggedData.mobilePhone;
    }
});

const manageFieldsVisibility = () => {
    if (hasConfiguration.value) {
        const tenantConfigs = Utils.getGenericConfig(store.tenantConfig.configurations.tenant) as TenantBookingConfiguration;

        if (_.isNull(tenantConfigs) === false && _.isUndefined(tenantConfigs) === false) {
            forceSeePrivacy.value = tenantConfigs.tenantOpenprivacytext.value as boolean;

            let settings = tenantConfigs.registrationWebsettings.value as string;
            let settingsModel = JSON.parse(settings) as RegistrationConfigItem[];
            let settingModelCustom = settingsModel.find((c) => c.key === "DEFAULT");

            const steps = store.stepsMade;
            if (steps.municipality || (steps.location && steps.location.city)) {
                var foundSettingModelCustom = settingsModel.find((c) => c.key === "city" && (c.value === steps.location.city || c.value == steps.municipality));
                if (foundSettingModelCustom) {
                    settingModelCustom = foundSettingModelCustom;
                }
            }

            nameVisibility.value = settingModelCustom.fields.find((c) => c.key === "firstname").showed;
            lastNameVisibility.value = settingModelCustom.fields.find((c) => c.key === "lastname").showed;
            mobilePhoneVisibility.value = settingModelCustom.fields.find((c) => c.key === "mobilephone").showed;
            emailVisibility.value = settingModelCustom.fields.find((c) => c.key === "email").showed;
            taxCodeVisibility.value = settingModelCustom.fields.find((c) => c.key === "cf").showed;
            podVisibility.value = settingModelCustom.fields.find((c) => c.key === "pod").showed;

            nameRequired.value = settingModelCustom.fields.find((c) => c.key === "firstname").required;
            lastNameRequired.value = settingModelCustom.fields.find((c) => c.key === "lastname").required;
            mobilePhoneRequired.value = settingModelCustom.fields.find((c) => c.key === "mobilephone").required;
            emailRequired.value = settingModelCustom.fields.find((c) => c.key === "email").required;
            taxCodeRequired.value = settingModelCustom.fields.find((c) => c.key === "cf").required;
            podRequired.value = settingModelCustom.fields.find((c) => c.key === "pod").required;

            if (podVisibility.value) {
                var podCheck = settingModelCustom.fields.find((c) => c.key === "pod").check;
                if (podCheck) {
                    if (podCheck.startsWith('^')) {
                        //caso di regex
                        var podCheckRgx = new RegExp(podCheck);

                        if (podCheckRgx) {
                            console.log(podCheckRgx);
                            podCheckRule.value = (text: string, isWidget: boolean) => {
                                return podCheckRgx.test(text);
                            };
                        }
                    }
                    else {
                        var podCheckFn = new Function("return " + podCheck)();

                        if (podCheckFn) {
                            podCheckRule.value = (text: string, isWidget: boolean) => {
                                return podCheckFn(text, steps, isWidget);
                            };
                        }
                    }
                }
            }
            // Nel caso di appuntamento per sportello online, l'email deve essere obbligatoria a prescindere

            if (steps.location.roomType === 2) {
                emailVisibility.value = true;
                emailRequired.value = true;
            }

            if (steps.spid) {
                if (route.query && route.query.response && _.isString(route.query.response)) {
                    const spidResponse = queryStringToJSON();
                    if (spidResponse) {
                        if (spidResponse.Response_IsSuccessful) {
                            name.value = spidResponse.Name;
                            lastname.value = spidResponse.FamilyName;
                            cf.value = "";
                            email.value = spidResponse.Email;
                            mobilephone.value = spidResponse.Telephone.replace("+39", "").trim();
                            authnReqId.value = spidResponse.authId;

                            disableInputFields();
                        } else {
                            // Rimandare alla pagina BookFormChoice
                            store.spidResponse = spidResponse;
                            router.replace({ name: "bookformchoice" });
                        }
                    } else {
                        // TODO: Popolare errore
                        router.replace({ name: "bookformchoice" });
                    }
                }
            }
        }
    }
};

const getbookingReceiveFriendlyCode = computed(() => {
    let label = t("messages.bookingReceiveFriendlyCode");
    label = label.replace("##ExternalLoginUrl##", getExternalLoginUrl.value);

    return label;
});

const nameLabel = computed(() => {
    let label = t("common.firstName");
    if (nameRequired.value) {
        label = label + " *";
    } else {
        label = label + " (" + t("common.optional") + ")";
    }
    return label;
});

const lastNameLabel = computed(() => {
    let label = t("common.lastName");
    if (lastNameRequired.value) {
        label = label + " *";
    } else {
        label = label + " (" + t("common.optional") + ")";
    }
    return label;
});

const mobilePhoneLabel = computed(() => {
    let label = t("common.phoneNumber");
    if (mobilePhoneRequired.value) {
        label = label + " *";
    } else {
        label = label + " (" + t("common.optional") + ")";
    }
    return label;
});

const emailLabel = computed(() => {
    let label = t("common.emailAddress");
    if (emailRequired.value) {
        label = label + " *";
    } else {
        label = label + " (" + t("common.optional") + ")";
    }
    return label;
});

const taxCodeLabel = computed(() => {
    let label = t("common.taxCode");
    if (taxCodeRequired.value) {
        label = label + " *";
    } else {
        label = label + " (" + t("common.optional") + ")";
    }
    return label;
});

const podLabel = computed(() => {
    let label = t("common.pod");
    if (podRequired.value) {
        label = label + " *";
    } else {
        label = label + " (" + t("common.optional") + ")";
    }
    return label;
});

const userNotesLabel = computed(() => {
    let label = t("common.bookingDetails");
    label = label + " (" + t("common.optional") + ")";
    return label;
});

const recaptchaValid = computed(() => {
    if (!formValidation.validateText(tokenReCaptcha.value)) {
        return false;
    }
    return true;
});

const disableInputFields = () => {
    nameEnabled.value = false;
    lastNameEnabled.value = false;
    taxCodeEnabled.value = false;
    emailEnabled.value = false;
    mobilePhoneEnabled.value = false;
};

const openAlertPrivacyDialog = () => {
    alertPrivacyModal.show();
};

const onPrivacyChanged = () => {
    if (!hasSeenPrivacy.value && forceSeePrivacy.value) {
        hasAcceptedPrivacy.value = false;
        openAlertPrivacyDialog();
    }
};

const openPrivacyDialog = () => {
    privacyModal.show();
};

const closePrivacyDialog = () => {
    alertPrivacyModal.hide();
    privacyModal.hide();
    hasSeenPrivacy.value = true;
};

const queryStringToJSON = () => {
    const obj: SpidItemResponse = JSON.parse(route.query.response.toString());
    return obj;
};

const onCaptchaVerified = (token: any) => {
    tokenReCaptcha.value = token;
};

const onCaptchaExpired = () => {
    tokenReCaptcha.value = "";
    (recaptcha as any).reset();
};

const submitBook = (event: any) => {
    saveError.value = false;
    reCaptchaErrorVisibility.value = true;

    validate.value.validate();
    validate.value.onSuccess((result: any) => {
        if (recaptchaValid.value && validate.value.isValid) {
            if (nameVisibility.value && !nameRequired.value && !name.value) {
                let element = document.getElementById("firstName");
                if (element.classList.value.indexOf("just-validate-success-field")) {
                    element.classList.remove("just-validate-success-field");
                }
            }

            if (lastNameVisibility.value && !lastNameRequired.value && !lastname.value) {
                let element = document.getElementById("lastName");
                if (element.classList.value.indexOf("just-validate-success-field")) {
                    element.classList.remove("just-validate-success-field");
                }
            }

            if (mobilePhoneVisibility.value && !mobilePhoneRequired.value && !mobilephone.value) {
                let element = document.getElementById("mobilephone");
                if (element.classList.value.indexOf("just-validate-success-field")) {
                    element.classList.remove("just-validate-success-field");
                }
            }

            if (emailVisibility.value && !emailRequired.value && !email.value) {
                let element = document.getElementById("email");
                if (element.classList.value.indexOf("just-validate-success-field")) {
                    element.classList.remove("just-validate-success-field");
                }
            }

            if (taxCodeVisibility.value && !taxCodeRequired.value && !cf.value) {
                let element = document.getElementById("cf");
                if (element.classList.value.indexOf("just-validate-success-field")) {
                    element.classList.remove("just-validate-success-field");
                }
            }

            if (podVisibility.value && !podRequired.value && !pod.value) {
                let element = document.getElementById("pod");
                if (element.classList.value.indexOf("just-validate-success-field")) {
                    element.classList.remove("just-validate-success-field");
                }
            }

            if (_.isNull(store.stepsMade) === false && _.isNull(store.stepsMade.interval) === false && _.isNull(store.stepsMade.interval.id) === false) {
                saving.value = true;

                const token = store.stepsMade.interval.id;

                if (cf.value == null) {
                    cf.value = "";
                }

                if (name.value == null) {
                    name.value = "";
                }

                const data = {
                    bookingSourceCode: "web",
                    token: token,
                    firstName: name.value,
                    lastName: lastname.value,
                    taxCode: cf.value.toUpperCase(),
                    mobilePhone: mobilephone.value,
                    email: email.value,
                    pod: pod.value,
                    notes: store.stepsMade.details,
                    reCaptchaToken: tokenReCaptcha.value,
                    reCaptchaPublicKey: recaptchaClientKey.value,
                    authnReqId: authnReqId.value
                };

                let friendlyCodeToEdit = null;
                if (store.bookedit) {
                    friendlyCodeToEdit = store.bookedit.friendlyCode;
                }

                api.submitBook(data, friendlyCodeToEdit)
                    .then((res) => {
                        store.bookingSubmitted = res.booking;
                        router.push({ name: "summary" });
                    })
                    .catch((err) => {
                        saveError.value = true;
                        if (err.response && err.response.data && err.response.data.details) {
                            saveErrorMessage.value = err.response.data.details[0].value;
                        }
                        console.log("PRENOTAZIONE NON ESEGUITA!");
                        console.log(err);
                    })
                    .finally(() => {
                        saving.value = false;
                    });
            }
        }
    });
    validate.value.onFail((err: any) => {
        if (nameVisibility.value && !nameRequired.value && !name.value) {
            let element = document.getElementById("firstName");
            if (element.classList.value.indexOf("just-validate-success-field")) {
                element.classList.remove("just-validate-success-field");
            }
        }

        if (lastNameVisibility.value && !lastNameRequired.value && !lastname.value) {
            let element = document.getElementById("lastName");
            if (element.classList.value.indexOf("just-validate-success-field")) {
                element.classList.remove("just-validate-success-field");
            }
        }

        if (mobilePhoneVisibility.value && !mobilePhoneRequired.value && !mobilephone.value) {
            let element = document.getElementById("mobilephone");
            if (element.classList.value.indexOf("just-validate-success-field")) {
                element.classList.remove("just-validate-success-field");
            }
        }

        if (emailVisibility.value && !emailRequired.value && !email.value) {
            let element = document.getElementById("email");
            if (element.classList.value.indexOf("just-validate-success-field")) {
                element.classList.remove("just-validate-success-field");
            }
        }

        if (taxCodeVisibility.value && !taxCodeRequired.value && !cf.value) {
            let element = document.getElementById("cf");
            if (element.classList.value.indexOf("just-validate-success-field")) {
                element.classList.remove("just-validate-success-field");
            }
        }

        if (podVisibility.value && !podRequired.value && !pod.value) {
            let element = document.getElementById("pod");
            if (element.classList.value.indexOf("just-validate-success-field")) {
                element.classList.remove("just-validate-success-field");
            }
        }
    });
};

const getExternalLoginUrl = computed(() => {
    let link = getUserDataExternalLoginLink.value;
    if (link) {
        let backUrlData: ExternalLoginBackUrlData = {
            tenantId: store.tenantSelected.id,
            stepsMade: store.stepsMade
        };

        let backUrlDataJson = JSON.stringify(backUrlData);
        let backUrlDataEnc64 = btoa(backUrlDataJson);
        let backUrlDataEncoded = encodeURIComponent(backUrlDataEnc64);

        link = link.replace("{returnUrl}", `data=${backUrlDataEncoded}`);
    }

    return link;
});

return (_ctx: any,_cache: any) => {
  const _component_KInputText = _resolveComponent("KInputText")!

  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_unref(t)("titles.insertYourData")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, [
          _createElementVNode("span", { innerHTML: getbookingReceiveFriendlyCode.value }, null, 8, _hoisted_5),
          (emailVisibility.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, ". " + _toDisplayString(_unref(t)("messages.bookingEmailReminderDocuments")), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("form", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (nameVisibility.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_KInputText, {
                  name: "firstName",
                  id: "firstName",
                  modelValue: name.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                  labelText: nameLabel.value,
                  disabled: !nameEnabled.value
                }, null, 8, ["modelValue", "labelText", "disabled"])
              ])
            ]))
          : _createCommentVNode("", true),
        (lastNameVisibility.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_KInputText, {
                  name: "lastName",
                  id: "lastName",
                  modelValue: lastname.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lastname).value = $event)),
                  labelText: lastNameLabel.value,
                  disabled: !lastNameEnabled.value
                }, null, 8, ["modelValue", "labelText", "disabled"])
              ])
            ]))
          : _createCommentVNode("", true),
        (mobilePhoneVisibility.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_KInputText, {
                  name: "mobilephone",
                  id: "mobilephone",
                  modelValue: mobilephone.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((mobilephone).value = $event)),
                  labelText: mobilePhoneLabel.value,
                  disabled: !mobilePhoneEnabled.value
                }, null, 8, ["modelValue", "labelText", "disabled"])
              ])
            ]))
          : _createCommentVNode("", true),
        (emailVisibility.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_KInputText, {
                  name: "email",
                  id: "email",
                  modelValue: email.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((email).value = $event)),
                  labelText: emailLabel.value,
                  disabled: !emailEnabled.value
                }, null, 8, ["modelValue", "labelText", "disabled"])
              ])
            ]))
          : _createCommentVNode("", true),
        (taxCodeVisibility.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_KInputText, {
                  name: "cf",
                  id: "cf",
                  modelValue: cf.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((cf).value = $event)),
                  labelText: taxCodeLabel.value,
                  disabled: !taxCodeEnabled.value
                }, null, 8, ["modelValue", "labelText", "disabled"])
              ])
            ]))
          : _createCommentVNode("", true),
        (podVisibility.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_KInputText, {
                  name: "pod",
                  id: "pod",
                  modelValue: pod.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((pod).value = $event)),
                  labelText: podLabel.value
                }, null, 8, ["modelValue", "labelText"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((hasAcceptedPrivacy).value = $event)),
              onChange: _cache[7] || (_cache[7] = ($event: any) => (onPrivacyChanged())),
              id: "privacy",
              name: "privacy"
            }, null, 544), [
              [_vModelCheckbox, hasAcceptedPrivacy.value]
            ]),
            _createElementVNode("label", _hoisted_23, [
              _createTextVNode(_toDisplayString(_unref(t)("privacy.privacyTextBeforeLink")) + " ", 1),
              _createElementVNode("a", {
                href: "#",
                onClick: _withModifiers(openPrivacyDialog, ["prevent"])
              }, _toDisplayString(_unref(t)("privacy.privacyLink")), 1),
              _createTextVNode(" " + _toDisplayString(_unref(t)("privacy.privacyTextAfterLink")), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_unref(VueRecaptcha), {
              id: "googlerecaptcha",
              ref_key: "recaptcha",
              ref: recaptcha,
              loadRecaptchaScript: true,
              onVerify: onCaptchaVerified,
              onExpired: onCaptchaExpired,
              language: localeCode.value,
              sitekey: _unref(recaptchaClientKey)
            }, null, 8, ["language", "sitekey"]),
            (!recaptchaValid.value && reCaptchaErrorVisibility.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(t)("required.recaptcha")), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("button", {
              type: "submit",
              onClick: submitBook,
              class: "btn btn-primary btn-progress",
              disabled: saving.value
            }, [
              _createTextVNode(_toDisplayString(_unref(t)("common.confirmBooking")) + " ", 1),
              (saving.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(t)("common.loadingText")), 1),
                    _hoisted_33
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_30)
          ])
        ])
      ])
    ]),
    (saveError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, _toDisplayString(saveErrorMessage.value || _unref(t)("messages.errorOnBookingSave")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "alertPrivacyRef",
      ref: alertPrivacyRef,
      class: "modal",
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "alertPrivacyModalLabel",
      "aria-hidden": "true",
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false"
    }, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("h2", _hoisted_40, _toDisplayString(attentionTitle.value), 1),
            _hoisted_41
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)("required.privacyRead")), 1)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-sm",
              onClick: openPrivacyDialog
            }, _toDisplayString(_unref(t)("privacy.privacyRead")), 1)
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      ref_key: "privacyRef",
      ref: privacyRef,
      class: "modal bd-example-modal-xl",
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "privacyModalLabel",
      "aria-hidden": "true",
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false"
    }, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("h2", _hoisted_47, _toDisplayString(privacyTitle.value), 1),
            _hoisted_48
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createVNode(Privacy)
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-sm",
              onClick: closePrivacyDialog
            }, _toDisplayString(_unref(t)("privacy.privacySeen")), 1)
          ])
        ])
      ])
    ], 512)
  ]))
}
}

})